import { Component, OnInit } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbDateStruct, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../../core/api.service';
import { FunctionsService } from '../../core/global/functions.service';
import { UtilityService } from '../../core/global/utility.service';

@Component({
  selector: 'app-organization-add-model',
  templateUrl: './organization-add-model.component.html',
  styleUrls: ['./organization-add-model.component.sass']
})
export class OrganizationAddModelComponent implements OnInit {
  public defaultUpdateId = '';
  addOrgObj: any = {};
  orgGenNo;
  searchInput: any = '';
  sortedtby: any = 'id';
  page: number = 0; // Enter 1 if you want to use the server side pagination 
  p;
  updateId = '';
  todayDate;
  presentDate = new Date();
  presentMonth = this.presentDate.getMonth() + 1;
  year = this.presentDate.getFullYear();
  ddate = { year: this.year, month: this.presentMonth, day: this.presentDate.getDate() + 1 };

  constructor(public activeModal: NgbActiveModal, private modalService: NgbModal, private _adminService: ApiService, private _functions: FunctionsService, private _utility: UtilityService) { }

  ngOnInit(): void {
    this.updateId = window.localStorage.getItem('pushOrgId');
    window.localStorage.removeItem('pushOrgId');
    this.todaysdate();
    this.dateChange();
    if (this.updateId) {
      this.getOrgDetails()
    }
  }

  getOrgDetails() {
    let wheredata=[]
    wheredata = [{ 'field': '`qr_organization`.`id`', 'value': this.updateId, 'type': 'WHERE', 'nested': '' }]
    let data = { 'orgId': this.updateId ,whereData:wheredata,searchText: this.searchInput, sortby: this.sortedtby, page: this.page};
    let url = "qr/org_list";
    this._adminService.post(url, data).subscribe((response) => {
      if (response.success == true) {
        this.addOrgObj.org_name = response.data[0].org_name;
        let respDate = new Date(response.data[0].start_date);
        let day = respDate.getDate();
        let Month = respDate.getMonth() + 1;
        let year = respDate.getFullYear();
        this.addOrgObj.person = response.data[0].no_of_person;
        this.ddate = { year: year, month: Month, day: day };
        this.dateChange()
      }
    })
  }
  dateChange() {
    if (this.ddate.day && this.ddate.month && this.ddate.year && this.ddate!=null) {
      let mysqlformatDate = this.ddate['year'] + '-' + ('0' + this.ddate['month']).slice(-2) + '-' + ('0' + this.ddate['day']).slice(-2);
      this.addOrgObj.date = mysqlformatDate
    } else {
      delete this.addOrgObj.date
    }
  }
  todaysdate() {
    const current = new Date();
    this.todayDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate() + 1
    };
  }
  save() {
    var error = 0;
    if (!this.addOrgObj.org_name) {
      error++;
      this._utility.toastWarning('Enter Organization Name');
    } 
    else if (!this.addOrgObj.person) {
      error++;
      this._utility.toastWarning('Enter No. of Person');
    }
    else if (!this.addOrgObj.date) {
      error++;
      this._utility.toastWarning('Select Event Date');
    }
    if (error == 0) {
      let url = 'qr/org_save';
      if (this.updateId != '') {
        this.addOrgObj.updateId = this.updateId;
      }
      this._adminService.post(url, this.addOrgObj).subscribe((response) => {
        if (response.success == true) {
          this._utility.toastSuccess(response.message);
          this.activeModal.close(true);
        } else {
          this._utility.toastError(response.message);
        }
      })
    }
  }

}
